import React from 'react';
import loadable from '@loadable/component';

import ModelList from './model-list';
import withPageComponents from '../../page/components/with-page-components';
import { Helpers } from '../../core/src/helpers';
import ThemeCSSLoader from './theme-css-loader';
import { WithTheme } from '../../hooks/useTemplateTheme';

import './mlp.less';

const SuppliesFinder = loadable(() => Helpers.retryFunc(() => import('../../supplies-finder')));

const MLP = ({ analyticsData }) => {
    let { isEspotOverride: showElicit } = analyticsData || {};
    return (
        <div className="mlp">
            <WithTheme CSSLoader={ThemeCSSLoader}>
                {showElicit && (
                    <SuppliesFinder
                        header="Find your ink or toner cartridges"
                        subHeader="Includes FREE Shipping"
                        mobileSubHeader="Includes FREE Shipping"
                    />
                )}
                <ModelList titleTag={showElicit ? 'h2' : 'h1'} />
            </WithTheme>
        </div>
    );
};

export default withPageComponents(MLP, { analyticsData: true, seo: true });
